<template>
    <div class="garyaBg">
    <!-- section 1 -->
    <section ref="animationSection"  class="mx-auto  flexmobile  px-20 mt-32">
        <div class="text-2xl text-white">
          <h1 class="self-start text-4xl  font-semibold text-white">Wireframes</h1>
            <p class="dancing-script text-white text-2xl md:text-3xl font-semibold mt-6 md:pt-12">Mid Fidelity Wireframes</p>
            <p class="pt-8 text-lg">Since the website was already live and the team had a solid understanding of user functionalities and requirements, the design process began with mid- fidelity wireframes.</p>
        </div>
        <div class="flex flexmobile mt-14 flex-row gap-1 justify-between">
            <div >
                <img loading="lazy" ref="beforeImage" :class="beforeImageClass" class="md:max-w-[600px] 4" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726663210/Donate_a_Wagon_1_fkdbpj.png" alt="">
            </div>
            <div>
                <img loading="lazy" ref="afterImage" :class="afterImageClass"  class="md:max-w-[600px] pt-44" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726663225/Contact_Page_1_ejkj7v.png" alt="">
            </div>
        </div>
    </section>
    <!-- sectionn  2 -->
    <section  class="mx-auto  text-white text-2xl px-20 mt-32">
        <p class="dancing-script text-white text-2xl md:text-3xl font-semibold pt-6">High Fidelity Wireframes</p>
        <img loading="lazy" class="mt-8" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726663203/Group_1927_hj2vem.png" alt="">
    </section>
    <!-- section 3 -->
    <section class="mx-auto flexmobile  text-white  px-20 mt-32">
        <h1 class="self-start text-4xl font-semibold text-white">Future Roadmap</h1>
        <p class="pt-6 text-lg md:pt-16"> <span class="text-rose-300 text-lgl">Promote and acknowledge feedback </span> on all the social media platforms of Warrior Wagons</p>
<p class="pt-6 text-lg ">Create a <span class="text-rose-300 text-lg"> “Shop for Warriors” </span>
page on the website which would promote the <span class="text-rose-300 text-lg">“Warrior Wagons’’ merchandise</span></p>
    
</section>

<!-- last section  -->
<section class=" flex flexmobile md:mb-44 px-20 mx-auto container relative md:top-60 justify-center flex-col flex-wrap mt max-md:mt-10">
        <h2 class="md:text-4xl text-center font-semibold text-white">View other Projects</h2>
        <div class="self-start mt-2 ml-4 max-md:max-w-full">
          <div class="flex justify-center  gap-5 max-md:flex-col">
            <article class="flex  w-full max-md:ml-0 max-md:w-full">
              <div class="pb-12 flex flex-col md:flex-row justify-between items-center font-bold text-white rounded-[50px] max-md:px-5 max-md:mt-10 max-md:max-w-full">
    <router-link to="NextProject">
        <div class="flex md:pt-20 cursor-pointer relative z-10 w-full max-w-full max-md:w-full max-md:h-auto">
            <img loading="lazy" class="w-full h-full object-cover" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726864991/Group_34207_1_t8ptsv.png" alt="">
        </div>
    </router-link>
    <router-link to="BakeryProject">
        <div class="flex cursor-pointer relative z-10 w-full max-w-full max-md:w-full max-md:h-auto  md:mt-0">
          <img loading="lazy" class="w-full h-full md:mt-24 object-cover" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726663407/Group_34338_1_jnybyb.png" alt="">
        </div>
    </router-link>
</div>
            </article>
          </div>
        </div>
      </section>
    </div>
</template>


<script>
export default{
name:'WangosProjectFour',
data() {
      return {
        beforeImageClass: 'opacity-0', // Initially hidden
        afterImageClass: 'opacity-0' // Initially hidden
      };
    },
    mounted() {
      const observerOptions = {
        root: null, // Uses the viewport as the root
        threshold: 0.1 // 10% of the element should be visible
      };
  
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Trigger animations when the section is in view
            this.beforeImageClass = 'animate__animated animate__zoomInLeft opacity-100';
            this.afterImageClass = 'animate__animated animate__zoomInRight opacity-100';
  
            // Ensure the animations only happen once by unobserving
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);
  
      // Observe the section with the images
      observer.observe(this.$refs.animationSection);
    }

}
</script>

<style>

</style>
